export default __webpack_public_path__ + "0c78daebcfc58e90b23a4018e8bc3af8.mp3";